var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showType == 'form-builder')?_c('div',{staticClass:"separator"},[_vm._v("\r\n    Page Break\r\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }